import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText
} from '@mui/material';

export default ({ open, onClose }) => (
  <Dialog open={open}>
    <DialogTitle>Order Success</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Your order has been completed successfully.
      </DialogContentText>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </DialogContent>
  </Dialog>
);
